import { Model } from 'backbone';
import { isFloat } from '../../../core/utils';
import _ from 'lodash';

const team_avatars_path = process.env.AVATARS_PATH;
const bye_rounds_ids = JSON.parse(process.env.BYE_ROUNDS || '[]');
/**
 * This is League Model Class
 */
export class Team extends Model {
	/**
	 * Set default model fields
	 * @returns object
	 */
	get defaults() {
		return {
			id:                          0,
			avatar:                      '',
			firstname:                   '',
			lastname:                    '',
			league_points:               0,
			round_league_points:         '-',
			league_scoreflow:            [],
			lineup:                      {},
			name:                        '',
			points:                      '-',
			round_points:                '-',
			league_ladder_current_round_points: '-',
			rank:                        0,
			rank_history:                [],
			scoreflow:                   [],
			user_id:                     0,
			points_against:              '-',
			win:                         0,
			loss:                        0,
			draw:                        0,
			points_difference:           '-',
			overall_different_points:    '-',
			wdl:                         [],
			last_5_wdl:                  [],
			current_round:               0,
			selected_round:              '',
			different_points:            0,
			players:                     {},
			ranks_difference:            '',
			prev_rank:                   '',
			overall_rank_difference:     '',
			current_round_league_points: '-',
			league_start_round:          0,
			current_round_points:        '-',
			value:                       '-',
			total_league_points_difference:  '-'
		};

	}

	setAvatar() {
		let avatar_version = this.get('avatar_version'),
			avatar = team_avatars_path + this.get('user_id') + '.png?v=' + avatar_version;

		this.set('avatar', avatar);

		return this;
	}

	updateLadderData() {
		this.setWDL()
			.calculatePointsAgainst()
			.setRoundPoints()
			.setDifferentPoints()
			.setRanksDifference()
			.setOverallRank()
			.setCurrentRoundPoints()
			.calculatePointsDifference();

		return this;
	}

	setRoundPoints() {
		let current_round = this.get('current_round'),
			selected_round = this.get('selected_round'),
			league_scoreflow = this.get('league_scoreflow'),
			league_points = this.get('league_points'),
			scoreflow = this.get('scoreflow'),
			start_round = this.get('league_start_round'),
			bye_rounds = this.get('bye_rounds'),
			league = this.get('league'),
			round_league_points = this.calculateRoundPoints(
				league_scoreflow, current_round, start_round, bye_rounds, league
			),
			round_points = this.calculateRoundPoints(
				scoreflow, current_round, start_round, bye_rounds, league
			),
			current_round_points = (scoreflow && scoreflow[current_round]) ?
				scoreflow[current_round] : '-',
			// eslint-disable-next-line max-len
			league_points_for_round = typeof (league_scoreflow && league_scoreflow[selected_round]) === "number" ? league_scoreflow[selected_round] : '-',
			// eslint-disable-next-line max-len
			league_ladder_current_round_points = !selected_round || selected_round === '-' ? league_points : league_points_for_round;

		this.set({
			round_league_points,
			round_points,
			current_round_points,
			league_ladder_current_round_points,
		});

		return this;
	}

	setCurrentRoundPoints() {
		let league_scoreflow            = this.get( 'league_scoreflow' ),
			current_round               = this.get( 'current_round' ),
			current_round_league_points =
				(league_scoreflow && league_scoreflow[ current_round ]) ?
					league_scoreflow[ current_round ] :
					'-';


		this.set( { current_round_league_points } );

		return this;
	}

	calculateRoundPoints(scoreflow, current_round, start_round, bye_rounds, league) {
		const isFinal = round_id => league && !league.isFinalRound(round_id);

		if ( scoreflow ) {
			let round_points = _.filter( scoreflow, ( item, round ) => {
				round = parseInt(round, 10);
				const is_not_final = isFinal(round);

				if (
					round <= current_round &&
					start_round <= round &&
					is_not_final
				) {
					return !(bye_rounds === 0 && bye_rounds_ids.includes(round));
				}
			} );

			round_points = _.sum( round_points );
			return round_points ? round_points : '-';
		}
		else {
			return '-';
		}
	}

	setWDL() {
		let scoreflow = this.get( 'league_scoreflow' ),
			current_round = this.get( 'current_round' ),
			league = this.get('league'),
			win = 0,
			draw = 0,
			loss = 0,
			wdl = [],
			last_5_wdl = [],
			league_start_round = parseInt(this.get('league_start_round'), 10);
		const isFinal = round_id => league && !league.isFinalRound(round_id);
		if( current_round ) {
			_.each( scoreflow, (score, id) => {
				const int_id = parseInt(id, 10);
				const round_id = league_start_round >= int_id ? league_start_round : int_id;
				const is_final = isFinal(round_id);

				if( round_id <= current_round && is_final ) {
					switch( score ) {
						case 1:
							draw++;
							wdl.push('D');
							break;
						case 2:
							win++;
							wdl.push('W');
							break;

						default:
							loss++;
							wdl.push('L');
							break;
					}
				}
			} );

			last_5_wdl = ( wdl.length > 5 ) ? wdl.slice( wdl.length - 5 ) : wdl;
			this.set({ win, draw, loss, wdl, last_5_wdl });
		}
		return this;
	}

	calculatePointsAgainst() {
		let fixtures = this.get( 'fixtures' ),
			league = this.get('league'),
			current_round = this.get( 'current_round' ),
			current_team_id = this.get( 'id' ),
			points_against = 0;
		const isNotFinal = round_id => league && !league.isFinalRound(round_id);

		if( fixtures ) {
			_.each( fixtures, ( fixture, round) => {
				round = parseInt(round, 10);
				const is_not_final = isNotFinal(round);
				if( round <= current_round && is_not_final ) {
					_.each( fixture, item => {
						let points = this.getPointsAgainst( item, round, current_team_id );
						if( points ) {
							points_against += points;
						}
					} );
				}
			} );
		}

		this.set( 'points_against', points_against );

		return this;
	}

	getPointsAgainst( fixture, current_round, current_team_id ) {
		let points_against = false;

		if( fixture.first_opponent.id === current_team_id ) {
			if(
				fixture.second_opponent.scoreflow &&
				fixture.second_opponent.scoreflow[ current_round ]
			) {
				points_against = fixture.second_opponent.scoreflow[ current_round ];
			}
			else {
				points_against = 0;
			}
		}
		else if( fixture.second_opponent.id === current_team_id ) {
			if(
				fixture.first_opponent.scoreflow &&
				fixture.first_opponent.scoreflow[current_round]
			) {
				points_against = fixture.first_opponent.scoreflow[current_round];
			}
			else {
				points_against = 0;
			}
		}

		return points_against;
	}

	setRanksDifference() {
		const current_rank = this.get( 'rank' ),
			rank_history = this.get( 'rank_history' ),
			current_round = this.get( 'current_round' ),
			ranks_difference = this.calculateCurrentRanksDifference(
				current_rank,
				rank_history,
				current_round
			);

		this.set( { ranks_difference } );

		return this;
	}

	setOverallRank() {
		let overall_rank = this.get( 'overall_rank' ),
			rank_history = this.get( 'rank_history' ),
			current_round = this.get( 'current_round' ),
			overall_rank_difference = this.calculateRanksDifference(
				overall_rank,
				rank_history,
				current_round
			);

		this.set( { overall_rank_difference } );

		return this;
	}
	calculateCurrentRanksDifference( rank, rank_history, current_round ) {
		let ranks_difference = '';

		if( rank_history ) {
			let rank_key = Object.keys( rank_history ),
				current_rank = rank_history[current_round] || rank,
				prev_rank = ( current_round && rank_history[current_round - 1] ) ?
					rank_history[current_round - 1] :
					rank_history[rank_key.length];

			if( current_rank < prev_rank ) {
				ranks_difference = 'ion-arrow-up-b';
			}
			else if( current_rank === prev_rank ){
				ranks_difference = 'ion-minus';
			}
			else {
				ranks_difference = 'ion-arrow-down-b';
			}
		}

		return ranks_difference;
	}
	calculateRanksDifference( current_rank, rank_history, current_round ) {
		let ranks_difference = '';

		if( current_rank && rank_history ) {
			let rank_key = Object.keys( rank_history ),
				prev_rank = ( current_round && rank_history[current_round] ) ?
					rank_history[current_round] :
					rank_history[rank_key.length];

			if( current_rank < prev_rank ) {
				ranks_difference = 'ion-arrow-up-b';
			}
			else if( current_rank === prev_rank ){
				ranks_difference = 'ion-minus';
			}
			else {
				ranks_difference = 'ion-arrow-down-b';
			}
		}

		return ranks_difference;
	}

	setDifferentPoints() {
		let {
			round_league_points,
			current_round,
			league_start_round,
			round_points,
			league_scoreflow,
			league_points
		} = this.attributes;

		let rounds_played = (current_round === league_start_round) ?
			1 : (current_round - (league_start_round || 1)) + 1;

		const rankings_rounds_played = _.size(league_scoreflow);

		let different_points = this.calculateDifferentPoints( round_league_points, rounds_played ),
			overall_different_points = this.calculateDifferentPoints( round_points, rounds_played ),
			total_league_points_difference =
				this.calculateDifferentPoints( league_points, rankings_rounds_played );

		this.set( { different_points, overall_different_points, total_league_points_difference } );

		return this;
	}

	calculateDifferentPoints( points, rounds_played ) {
		let different_points = '-';

		if (
			points !== '-' &&
			points !== 0 &&
			rounds_played !== 0
		) {
			different_points = points / rounds_played;
		}

		return isFloat(different_points) ? different_points.toFixed(2) : different_points;
	}

	calculatePointsDifference() {
		let round_points = this.get( 'round_points' ),
			points_against = this.get( 'points_against' ),
			points_difference = round_points - points_against;

		points_difference = points_difference ? points_difference : '-';

		this.set({ points_difference });
		return this;
	}


}

export default Team;